import React, { useState, useEffect } from 'react';

interface FooterMainProps { }
const FooterMain: React.FC<FooterMainProps> = () => {

    return (
        
        <div className='justify-content-center justify-content h-6'> 
            <a href='https://www.arivonix.ai/terms-of-use/' className='text-reset text-decoration-none'>Terms of use</a>
            <a href='https://www.arivonix.ai/privacy-policy/' className='mx-4 text-reset text-decoration-none'>Privacy & Legal</a>
            <a href='https://www.arivonix.ai/contact-us/' className='text-reset text-decoration-none'>Contact</a>
            </div>

        
    );
};

export default FooterMain;